exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-effects-js": () => import("./../../../src/pages/effects.js" /* webpackChunkName: "component---src-pages-effects-js" */),
  "component---src-pages-fiber-js": () => import("./../../../src/pages/fiber.js" /* webpackChunkName: "component---src-pages-fiber-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

